import React from "react";

import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbScrollView from "components/RbScrollView";

import UsersHeader from "./UsersHeader";
import UsersList from "./UsersList";

function UsersScreen() {
  return (
    <RbFlexView direction="column">
      <RbFlexViewItem>
        <UsersHeader />
      </RbFlexViewItem>
      <RbFlexViewItem grow={1}>
        <RbScrollView>
          <UsersList />
        </RbScrollView>
      </RbFlexViewItem>
    </RbFlexView>
  );
}

export default React.memo(UsersScreen);
